import { Icon } from "components";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import { Badge } from "ui/components/badge";
import { TYPES } from "@/components/status/constant";

export const TypeDisplay = ({ value }) => {
  const typeInfo = TYPES[value];
  if (!typeInfo) return null;

  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge variant="outline" className="h-5">
          <Icon icon={typeInfo.icon} className="text-muted-foreground size-4" />
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{typeInfo.label}</TooltipContent>
    </Tooltip>
  );
};
